import axios from 'axios';
import API_BASE_URL from '../config/api';

// Log API base URL for debugging (always log for troubleshooting)
console.log('[API Service] API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 120000, // 120s — local Laravel dev can be slow on large SQLite DBs
});

// Add token to requests automatically
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Let the browser set multipart boundary (manual Content-Type breaks file uploads).
    if (config.data instanceof FormData) {
      if (config.headers?.delete) {
        config.headers.delete('Content-Type');
      } else if (config.headers) {
        delete config.headers['Content-Type'];
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors (unauthorized) - auto logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = !!sessionStorage.getItem('token');
      if (hadToken) {
        sessionStorage.setItem(
          'auth_notice',
          'Your account was signed in on another device. Please log in again.'
        );
      }
      sessionStorage.removeItem('token');
      const currentPath = window.location.pathname;
      if (currentPath !== '/' && currentPath !== '/login' && currentPath !== '/register') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
